<lib-ph-bhp-login [isUserName]="isUserName" [clientData]="config.clientData" (childData)=onChildData($event)></lib-ph-bhp-login>
